module.exports = __webpack_public_path__ + "efbf15f7303212c3db4c980f90f71a32.pdf";